import React from 'react';
import { Button, BUTTON_VARIANTS, Dialog } from 'cdk-radial';
import './styles/confirmation.scss';
import './styles/consentDialog.scss';
import { Loader } from 'cdk-radial';
import { consentConstant } from '../../constants/consentConstant';

//Error Constants
const ADDENDUM_QUERY_ERROR =
  'error in querying getAddendumSignatureCoordinates';
const NO_ADDENDUM_MESSAGE = 'This API doesn’t have Addendum Integration. Please click on "Yes" to complete the consenting process.';

//STATUS CONSTANTS
const CREATING_SIGNING_SESSION = 'Creating Signing Session';

const DATA_RIGHTS_CONSENT = 'Data Rights Consent';
const ONE_CLICK = 'one click'
const TERMS_AND_CONDITIONS = 'Terms and Conditions';
const ADDENDUM_TO_MASTER_SERVICES_AGREEMENT = 'ADDENDUM TO MASTER SERVICES AGREEMENT';
const SOLUTION = 'solution';

class ConsentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openBuyerDetailsPopUp: false,
      docUrl: '',
      disableAcceptanceBtn: true,
      isRaised: false,
      src: '',
      loading: true,
      spinnerText: CREATING_SIGNING_SESSION,
      dialogTitle: TERMS_AND_CONDITIONS,
      showCloseButton: true
    };
  }

  async componentDidMount() {
    let type = this.props.type;
    if (type === SOLUTION) {
      this.setState({
        loading: false,
        termsType: this.props.consentType,
        terms: this.props.preLoadedAppTerms,
        signatureCoordinates: this.props.signatureCoordinates,
      });
      return;
    }
    if (type === consentConstant.MONETISATION_SERVICE_AGREEMENT) {
      this.setState({
        dialogTitle: ADDENDUM_TO_MASTER_SERVICES_AGREEMENT,
      });
    }
    if (type === DATA_RIGHTS_CONSENT) {
      this.setState({
        termsType: ONE_CLICK,
        dialogTitle: DATA_RIGHTS_CONSENT,
        loading: true,
        showCloseButton: true,
      });
    } else {
      if (this.props.docUrl) {
        this.setAddendumType();
      }
    }
  }

  setAddendumType = async () => {
    if (this.props.oneClickConsentOnly) return;

    const { provider } = this.props;
    try {
      this.setState({
        spinner: false,
        loading: false,
      });

      if (!provider) {
        console.error('provider is undefined', this.props);
        return this.props.onClose;
      }

      const addendum = provider.addendum;

      if (!addendum) {
        console.log('consent type is one click, no addendum key found');
        return;
      }
    } catch (e) {
      console.error(ADDENDUM_QUERY_ERROR, e);
    }
  };

  renderCustomFooter = () => {
    const footerText = `${
      this.props.type === consentConstant.MONETISATION_SERVICE_AGREEMENT
        ? 'Do you accept?  '
        : ''
    }By clicking “yes”, you represent and warrant that you are authorized to agree to these terms and conditions on behalf of the dealership(s) you selected.`;
    return (
      <div className="custom-footer">
        <div className="confirmation-text">{footerText}</div>
        <div>
          <span className="consent-dialog_button">
            <Button
              style={{ width: '160px' }}
              text="No"
              variant={BUTTON_VARIANTS.SECONDARY}
              onClick={this.props.onClose}
              raised={!this.state.isRaised}
            ></Button>
          </span>
          <span className="consent-dialog_button">
            <Button
              style={{ width: '160px' }}
              text="Yes"
              variant={BUTTON_VARIANTS.PRIMARY}
              onClick={() => {
                if (this.props.type === DATA_RIGHTS_CONSENT) {
                  this.props.onAccept();
                  this.props.dataRightsAgreementAccepted();
                } else {
                  this.props.onAccept({
                    consentStatus: consentConstant.CONSENT_ACCEPTED,
                  });
                }
              }}
              raised={this.state.isRaised}
            ></Button>
          </span>
        </div>
      </div>
    );
  };

  renderCustomFooterComponent = () => {
    return (
      <div className="custom-footer-for-no-addendum">
        <span className="consent-dialog_button">
          <Button
            text="No"
            variant={BUTTON_VARIANTS.SECONDARY}
            onClick={this.props.onClose}
            raised={!this.state.isRaised}
          ></Button>
        </span>
        <span className="consent-dialog_button">
          <Button
            text="Yes"
            variant={BUTTON_VARIANTS.PRIMARY}
            onClick={() => {
              this.props.onAccept({
                consentStatus: consentConstant.CONSENT_ACCEPTED,
              });
            }}
            raised={this.state.isRaised}
          ></Button>
        </span>
      </div>
    );
  };

  render() {
    if (this.state.error) {
      return null;
    }

    if (!this.props.docUrl) {
      return (
        <div>
          <div className={'default-fortellis-dialog consent-dialog'}>
            <Dialog
              isOpen={true}
              onClose={this.props.onClose}
              hideHeader
              id="consent-dialog"
              hideCloseButton={false}
              className="consent-dialog-with-no-addendum"
              renderCustomFooterComponent={this.renderCustomFooterComponent}
            >
              <div className="no-addendum-message">{NO_ADDENDUM_MESSAGE}</div>
            </Dialog>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className={'default-fortellis-dialog consent-dialog'}>
            <Dialog
              isOpen={true}
              onClose={this.props.onClose}
              title={this.state.dialogTitle}
              id="consent-dialog"
              hideCloseButton={false}
              className={
                this.props.className
                  ? `consent_dialog ${this.props.className}`
                  : 'consent_dialog'
              }
              renderCustomFooterComponent={this.renderCustomFooter}
            >
              <div className={'consent-pdf-container'}>
                {(this.props.preLoadedAppTerms || this.props.docUrl) && (
                  <embed
                    type="application/pdf"
                    //src={this.props.preLoadedAppTerms || this.props.docUrl}
                    src={
                      document.documentMode
                        ? this.props.docUrl
                        : this.props.preLoadedAppTerms || this.props.docUrl
                    }
                    style={
                      this.state.openBuyerDetailsPopUp &&
                      !!document.documentMode //document.documentMode returns some value only if the userAgent is IE browser otherwise it return undefined..
                        ? { width: '100%', height: 'inherit', display: 'none' }
                        : { width: '100%', height: 'inherit' }
                    }
                  />
                )}
              </div>
            </Dialog>
            {this.props.showInProgressState ? (
              <Dialog
                isOpen={true}
                className={this.props.className}
                title={`Accept ${consentConstant.MONETISATION_SERVICE_AGREEMENT}`}
                id="confirmation-dialog"
                hideCloseButton={true}
                buttonsProps={[]}
              >
                <Loader label={this.props.inProgressStateMessage} />
              </Dialog>
            ) : null}
          </div>
        </div>
      );
    }
  }
}


export default ConsentDialog;
